import { UseStateType } from "@relode/core";
import * as React from "react";

import { candidates } from "../../../../shared/backend/controllers";

const CandidatesContext = React.createContext(undefined);

export const CandidatesProvider = (props: { children?: React.ReactNode }) => {
    const [ids, setIds] = React.useState<
        candidates.CandidateSearchLeadIdJobIdResponse[]
    >([]);
    const value = React.useMemo(() => [ids, setIds], [ids]) as UseStateType<
        candidates.CandidateSearchLeadIdJobIdResponse[]
    >;
    return <CandidatesContext.Provider value={value} {...props} />;
};
